import script from "./KycForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./KycForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__